import { constructSectionTemplate } from '../Sections';

class Assessment {
  constructor(contentfulNode) {
    this.headline = contentfulNode?.headline;
    this.headlineUnderline = contentfulNode?.headlineUnderline;
    this.subHeadline = contentfulNode?.subHeadline;
    this.assessmentName = contentfulNode?.name;
    this.slug = contentfulNode?.slug;
    this.localizationSlug = contentfulNode?.localizationSlug;
    this.video = contentfulNode?.video?.embedUrl;
    this.heroImage = contentfulNode?.heroImage?.gatsbyImageData || '';
    this.videoSubtitle = contentfulNode?.videoSubtitle;
    this.contactButton = contentfulNode?.contactButton;
    this.contactButtonText = contentfulNode?.contactButtonText || 'Contact Us';
    this.richDescription = contentfulNode?.richDescription;

    this.sectionTemplates = contentfulNode.assessmentSectionTemplates
      ? contentfulNode.assessmentSectionTemplates.map(template => constructSectionTemplate(template))
      : null;
  }
}

export default Assessment;
